import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";

import magnifiAPI from "../../services/api/magnifi";
import { workspace } from "../schemas";

export const getWorkspaceDetailsOfOrganization = createAsyncThunk(
  "magnifiUser/getWorkspaceDetailsOfOrganization",
  async (payload) => {
    try {
      const response = await magnifiAPI.getOrganizationDetails({ payload });
      return {
        ...response.data,
        ...(response.data.status ? normalize(response.data.data.workspaces, [workspace]) : {}),
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getWorkspaceUsers = createAsyncThunk("magnifiUser/getWorkspaceUsers", async (payload) => {
  try {
    const response = await magnifiAPI.getWorkspaceUsers(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getWorkspaceAssignableUsers = createAsyncThunk(
  "magnifiUser/getWorkspaceAssignableUsers",
  async (payload) => {
    try {
      const response = await magnifiAPI.getWorkspaceAssignableUsers(payload);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error.response.data;
    }
  },
);

export const assignWorkspaceUser = createAsyncThunk("magnifiUser/assignWorkspaceUser", async (payload) => {
  try {
    const response = await magnifiAPI.assignWorkspaceUser(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response.data;
  }
});

export const getWorkspaces = createAsyncThunk("magnifiUser/getWorkspaces", async (payload) => {
  try {
    const response = await magnifiAPI.getWorkspaces(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createWorkspaceUser = createAsyncThunk(
  "magnifiUser/createWorkspaceUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magnifiAPI.createWorkspaceUser(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateWorkspaceMember = createAsyncThunk("magnifiUser/updateWorkspaceMember", async (payload) => {
  try {
    const response = await magnifiAPI.updateWorkspaceMember(payload);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error.response.data;
  }
});

export const removeWorkspaceMember = createAsyncThunk("magnifiUser/removeWorkspaceMember", async (payload) => {
  try {
    const response = await magnifiAPI.removeWorkspaceMember(payload);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error.response.data;
  }
});

export const deleteWorkspace = createAsyncThunk("magnifiUser/removeWorkspaceMember", async (payload) => {
  try {
    const response = await magnifiAPI.deleteWorkspace(payload);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getWorkspacesByCategory = createAsyncThunk("magnifiUser/getWorkspacesByCategory", async (payload) => {
  try {
    const response = await magnifiAPI.getWorkspacesByCategory(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getMeWorkspaces = createAsyncThunk("magnifiUser/getMeWorkspaces", async (payload) => {
  try {
    const response = await magnifiAPI.getMeWorkspaces(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
